import React, { useEffect, useState } from "react";
import ChangePremiumFee from "./ChangePremiumFee";
import ChangePassword from "./ChangePassword";
import LinkTelegramAccount from "./LinkTelegramAccount";
import AutomationSettings from "components/UserSettings/AutomationSettings";
import { apiGetIBAccountDetails } from "api/apiTws";
import { useSelector } from "react-redux";
import { selectAutomationAllowed } from "store/slices/main";
import { Divider } from "antd";

const UserSettings = () => {
  const automationAllowed = useSelector(selectAutomationAllowed);
  const [ibAccountDetails, setIbAccountDetails] = useState(null);

  const fetchIbAccountDetails = async () => {
    try {
      const response = await apiGetIBAccountDetails();
      setIbAccountDetails(response);
    } catch (err) {
      console.error("Failed to fetch IB account details:", err);
      setIbAccountDetails(null);
    }
  };
  useEffect(() => {
    if (automationAllowed) {
      fetchIbAccountDetails();
    }
    document.title = "Settings | Dindicator Dashboard";
  }, []);

  return (
    <>
      <Divider orientation="left">User Settings</Divider>
      <div className="cards-wrapper">
        <ChangePassword />
        <ChangePremiumFee />
        <LinkTelegramAccount />
      </div>
      {automationAllowed && ibAccountDetails && (
        <AutomationSettings
          ibcStatus={ibAccountDetails?.ibcStatus}
          fetchIbAccountDetails={fetchIbAccountDetails}
        />
      )}
    </>
  );
};

export default UserSettings;
